import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function SeasonalTagsMetaData(
  section: string,
): PageMetaDataValues {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "NDR 2025",
    startDate: "2025-08-15",
    endDate: "2025-08-20",
    eventStatus: "https://schema.org/EventScheduled",
    eventAttendanceMode: "https://schema.org/MixedEventAttendanceMode",
    location: {
      "@type": "Place",
      name: "Singapore",
      address: {
        "@type": "PostalAddress",
        streetAddress: "1000 Toa Payoh North",
        addressLocality: "Singapore",
        postalCode: "318994",
        addressCountry: "Singapore",
      },
    },
  };
  const metaTags: MetaTagsProps = {
    title: "NDR 2025: Himpunan Hari Kebangsaan Singapura | Beritaharian.sg",
    description:
      "Perutusan tahunan yang disampaikan oleh Perdana Menteri Singapura kepada seluruh negara, pada hari Ahad pertama atau kedua selepas Hari Kebangsaan.",
    slug: section,
    jsonLd,
  };

  const gaData: GADataProps = {
    level2: section,
    title: "NDR_2025_Index",
    section: section,
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
